import { UPDATE_STEP, PLANS, ESTIMATE, REQ_SENT, REQ_FAILED, LOADING } from './SubscribeActions';

import { COUNTRIES } from '../../util/countries';

const INITIAL_STATE = {
  countries: COUNTRIES,
  sent: false,
  plans: {},
  model: {},
  estimation: {},
  error: undefined,
  paymentLoading: false,
};

const SubscriptionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_STEP:
      return {
        ...state,
        model: action.model,
      };
    case PLANS:
      return {
        ...state,
        plans: action.plans,
        paymentLoading: false,
      };
    case ESTIMATE:
      return {
        ...state,
        estimation: action.data,
        sent: false,
      };
    case REQ_SENT:
      return {
        ...state,
        sent: true,
        error: undefined,
        paymentLoading: false,
      };
    case REQ_FAILED:
      return {
        ...state,
        error: action.error,
        sent: true,
        paymentLoading: false,
      };
    case LOADING: {
      return {
        ...state,
        paymentLoading: action.value,
      };
    }
  }

  return state;
};

export default SubscriptionReducer;
